
    const data = {"name":"src/core/icons/format-align-right","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M3 3h18v2H3V3m6 4h12v2H9V7m-6 4h18v2H3v-2m6 4h12v2H9v-2m-6 4h18v2H3v-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            